import { render } from "./ReportCertDown.vue?vue&type=template&id=04ed2cbc"
import script from "./ReportCertDown.vue?vue&type=script&lang=js"
export * from "./ReportCertDown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__